import React from 'react';
import { ClockIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="py-12 px-4 bg-red-50 border-y border-red-100" data-id="element-307">
      <div className="max-w-3xl mx-auto text-center" data-id="element-308">
        <div className="flex justify-center mb-4" data-id="element-309">
          <ClockIcon className="w-12 h-12 text-red-600 animate-pulse" data-id="element-310" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-red-600 mb-4" data-id="element-311">
          ⏰ Questa offerta speciale non resterà disponibile a lungo
        </h2>
        <p className="text-lg text-gray-800 mb-8" data-id="element-312">
          Per un periodo limitato puoi accedere al MegaPack Maestro Musicale
          360° con uno sconto straordinario. Dopo la scadenza del timer, il
          prezzo potrebbe aumentare.
        </p>
        <div className="flex justify-center" data-id="element-313">
          <CountdownTimer variant="dark" data-id="element-314" />
        </div>
      </div>
    </section>;
}